import { MouseEventHandler, type FunctionComponent, } from "react"
import * as ICONS from "@bracket/react-icons";

import "./IconButton.scss";



export declare type IconButtonProps = {
	icon: keyof typeof ICONS;
	iconprops?: any;
	onClick?: MouseEventHandler<HTMLDivElement>;
};


export const IconButton: FunctionComponent<IconButtonProps> = ({
	icon,
	iconprops = {},
	onClick = () => { },
}) => {

	const classes = () => [ `icon-button` ].join(" ");
	const Icon = ICONS[icon] as FunctionComponent<{}>;

	return (
		<div className={classes()} onClick={onClick}>
			<Icon {...iconprops} />
		</div>
	);

}
